<template>
  <div>
    <Tabs
      type="card"
      :animated="false"
      v-model="tabValue"
    >
    <TabPane :label="$t('RepeatPersonnel')"  name="rcPersonnel"
     ></TabPane>
    </Tabs>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="120"
      ref="FormComponent"
      @handleReset="handleReset"
      @onFormChange="onFormChange"
    >
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot4"
        v-if="isShowPotentialScore"
      >
        <FormItem :label="$t('Potential_Rating')"
          ><!-- 潜能评分 -->
          <Select v-model="formItem.potentialScore" clearable>
            <Option
              v-for="item in PotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot5"
        v-if="tabName != 'PerformanceEvaluation'"
      >
        <FormItem :label="$t('Emp_Ach_mess9')"
          ><!-- 确认状态 -->
          <Select v-model="formItem.peoPleBoardStatus" clearable>
            <Option
              v-for="item in PeoPleBoardStatus"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot6"
        v-if="tabName != 'PerformanceEvaluation'"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot7"
        v-if="tabName != 'PerformanceEvaluation'"
      >
        <FormItem :label="$t('Carlsberg_Band')"
          ><!-- 嘉士伯级别 -->
          <Select v-model="formItem.hcmBand" clearable>
            <Option v-for="item in Band" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
     
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="colHidden"
      :data="data"
      @on-selection-change="onSelectionChange"
      style="margin: 20px 0"
      ref="selection"
    >
      <template slot-scope="{ row, index }" slot="comment" style="width: 100%">
        <Input
          type="textarea"
          v-model="row.comment"
          :autosize="true"
          :disabled="row.selsetDisabled"
          @on-change="targetItemChange(row, index, 'comment')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="openApplyPop(row, index)"
        ></Button>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="movment"
        style="width: 100%;"
      >
      <div style="display:flex;align-items: center;">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onEditItem(row, index, 'overall')"
        >
          {{ $t("movment") }}
        </Button>
        <div>{{row[lang == "zh" ? "movment" : "movmentEName"]}}</div>
      </div>

      </template>
      <template
        slot-scope="{ row, index }"
        slot="potentialScore"
        style="width: 100%;"
      >
      <div style="display:flex;align-items: center;">

        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
        <Select
          v-model="row.potentialScore"
          transfer
          :disabled="true"
        >
          <Option
            v-for="item in PotentialScore"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </div>

      </template>
    </Table>
    <div
      style="
         margin: 20px 0;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-items: flex-end;
      "
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <div>
       
        <Button
          type="primary"
          style="margin-top: 15px"
          @click="submitAchApprovalPotentialData"
          :disabled="loading"
          ><!-- 提交 -->{{ $t("Submit") }}</Button
        >
       
      </div>
    </div>
    <Modal :title="$t('MeetingDetails')" width="1200" v-model="CurriculumVitaeModalValue">
      <Form inline label-position="left" :label-width="80">
        <Row :gutter="10">
          <Col span="5">
            <FormItem :label="$t('Employee_Code')">
              <!-- 员工号 -->
              <Input v-model="viteItem.empCode" disabled></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label="$t('Name')"
              ><!-- 员工姓名 -->
              <Input
                v-model="viteItem.userName"
                disabled
                v-if="lang == 'zh'"
              ></Input>
              <Input v-model="viteItem.userEName" disabled v-else></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table
        :columns="viteColumns"
        :data="viteData"
        border
        :loading="viteLoading"
      >
       <template
        slot-scope="{ row, index }"
        slot="potentialScore"
        style="width: 100%;"
      >
      <div style="display:flex;align-items: center;">

        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onViteEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
        <Select
          v-model="row.potentialScore"
          transfer
          :disabled="true"
        >
          <Option
            v-for="item in PotentialScore"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </div>

      </template>
      </Table>
    </Modal>
    <PotentialRange ref="PotentialRangeRef" @onSetScore="onSetScore" />
  </div>
</template>

<script>
import FormComponent from "./components/FormComponent.vue";
import AchAssessComponentCell from "./components/AchAssessComponentCell.vue";
import AchAssessComponentProportion from "./components/AchAssessComponentProportion.vue";
import PotentialRange from "./components/PotentialRange.vue";

import axios from "axios";
import "./js/westeros.js";
import DateUtil from "@/util/DateUtil";
export default {
  components: {
    FormComponent,
    AchAssessComponentCell,
    AchAssessComponentProportion,
    PotentialRange
  },
  data() {
    return {
      date: new DateUtil(),
      // 履历对话框
      CurriculumVitaeModalValue: false,
      // 履历对话框表格的值
      viteData: [],
      viteLoading: false,
      viteItem: {},
      prevent: false,
      formItem: {},
      searchItem: { year: "" },
      loading: false,
      total: 0,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 50,
      },
      data: [],
      dataTable: [],
      spinShow: false,
      id: "",
      Score: [],
      tabName: "",
      PotentialScore: [],
      PeoPleBoardStatus: [],
      ManagementLevel: [],
      Band: [],
      isShowPotentialScore: true,
      editIndex: '',
      selectList:[],
      tabValue: 'rcPersonnel'
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    viteColumns() {
      return [
        {
          title: this.$t('Meeting_Subjects'),
          key: "meetingName",
          align: "center",
          minWidth: 90,
        },
        {
          title:this.$t('Potential_Rating'),
          key: "potentialScore",
          slot: "potentialScore",
          align: "center",
          minWidth: 90,
        },
        {
          title: this.$t('MeetingEndDate'),
          key: "date",
          align: "center",
          minWidth: 90,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.date, "YYYY-MM-DD HH:mm")
            );
          },
        },
      ];
    },
    columns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: this.$t("PB_Performance__Sheet") /* 绩效表单 */,
          key: "action",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "left",
        },
        {
          title: this.$t("Emp_Ach_mess9") /* 审批状态 */,
          key: "status",
          align: "center",
          minWidth: 120,
          fixed: "left",
          hidden: this.tabName == "PerformanceEvaluation" ? true : false,
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120,
          // sortable: true
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("movment") /* 绩效趋势 */,
          key: this.lang == "zh" ? "movment" : "movmentEName",
          align: "center",
          slot: "movment",
          width: 195,
        },
        {
          title: this.$t("Potential_Rating") /* 潜能评分 */,
          key: "potentialScore",
          slot: "potentialScore",
          align: "center",
          width: 200,
        },
        {
          title: this.$t("TalentCategory") /* 人才类别 */,
          key: this.lang == "zh" ? "talentCategoryName" : "talentCategoryEName",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("Remarks") /* 备注 */,
          slot: "comment",
          align: "center",
          minWidth: 160,
          hidden: this.tabName == "PerformanceEvaluation" ? true : false,
        },
        {
          title: this.$t('MeetingDetails') /* 会议明细 */,
          slot: "action1",
          align: "center",
          minWidth: 160,
          hidden: this.tabName == "PerformanceEvaluation" ? true : false,
        },
      ];
    },
    colHidden: function () {
      //重点
      return this.columns.filter(function (e) {
        return !e.hidden;
      });
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  mounted() {
    this.getListData()
  },
  created() {
    this.searchNewPotentialYear()
  },
  watch: {
    "searchItem.year"(val) {
      // 当年度>2025年之后 潜能评分列就隐藏不要显示了
      this.isShowPotentialScore = true;
      if (val > "2025") {
        this.isShowPotentialScore = false;
      }
    },
  },
  methods: {
    onViteEditItem(row, index, type) {
      row.bePotentialSubmit = '1'
      this.$refs.PotentialRangeRef.onEditItem(row, type);
      this.$refs.PotentialRangeRef.isShowPrePotential = false
    },
    submitAchApprovalPotentialData() {
       if (this.selectList.length > 0) {
        this.$Modal.confirm({
          title: this.$t("longText53"),
          onOk: () => {
            this.axios.post('/achApprovalPotential/submitAchApprovalPotentialData',this.selectList).then(res => {
                this.getData();
            })
          },
        });
      } else {
        this.$Message.error(this.$t("Emp_Ach_mess6"));
      }
    },
    onSelectionChange(arr) {
      this.selectList = arr
    },
     searchNewPotentialYear() {
      this.axios.post('/achReport/searchNewPotentialYear',{}).then(res => {
        this.$nextTick(() => {
          this.$refs.FormComponent.formItem.year = res + '';
          this.searchItem.year = res + '';
          this.getData();
        });
      })
    },
    onSetScore(e) {
        this.$set(this.data[this.editIndex], "newPotentialScore", e.score);
        this.getData(JSON.stringify(this.searchItem));
    },
    onEditItem(row, index, type) {
      this.editIndex = index;
      this.$refs.PotentialRangeRef.onEditItem(row, type);
      this.$refs.PotentialRangeRef.isShowPrePotential = false
    },
    onFormChange(e) {
      if (e.key == "year") {
        this.searchItem.year = this.date.dateVal(e.value, "YYYY");
      }
    },

    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.Score = res.Score;
          this.PotentialScore = res.NewPotentialScore;
          this.$refs.FormComponent.functionList = res.functionList;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.PeoPleBoardStatus = res.ApprovalPotentialStatusList;
          this.ManagementLevel = res.ManagementLevel;
          this.Band = res.Band;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        id: this.id,
        ...this.pageInfo,
        ...this.searchItem,
        repeatFlag: "1",
      };
      let url = "/achApprovalPotential/searchAchApprovalPotentialData";
      this.loading = true;
      this.dataTable = [];
      axios.post(url, obj).then((res) => {
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        if (res) {
          this.data = res.achPeopleBoardList;
          this.total = parseInt(res.pageInfo.total);
          if (res.normalTableList) {
            this.dataTable = res.normalTableList;
          }

        }
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },

    async targetItemChange(row, index, key) {
      key && this.$set(this.data[index], key, row[`${key}`]);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },

    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.achApplyId +
        "&serialnumber=" +
        row.serialnumber +
        "&achStage=" +
        row.achStage +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
    },
    handleReset() {
      this.formItem = {};
      this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
    },
    openApplyPop(row, index) {
      this.CurriculumVitaeModalValue = true;
      this.viteLoading = true;
      this.viteItem = {
        empCode: row.empCode,
        userName: row.userName,
        userEName: row.userEName,
      };
      let obj = {
        serialnumber: row.serialnumber,
        year: row.year,
      };
      this.axios
        .post("/achApprovalPotential/searchAchApprovalPotentialList", obj)
        .then((res) => {
          if (res) {
            this.viteData = res;
            this.viteLoading = false;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #459846;
  color: #ffffff;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  /* border-top: 1px solid #ffffff; */
  background: #ffffff;
  border-top: 1px solid #459846 !important;
  border-left: 1px solid #459846 !important;
  border-right: 1px solid #459846 !important;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchApprovalPotential.vue